import { configureStore } from "@reduxjs/toolkit";
import superAdminReducer from "./slices/superAdmin";
// import chatReducer from "./slices/chatSlice";

export const store = configureStore({
  reducer: {
    superAdmin: superAdminReducer,
    // chat: chatReducer,
  },
});
